import React, { useState, useEffect, useContext } from 'react'
import AdminControl from 'src/pages/AdminControl/UsersAdmin/AdminControl'
import { useHistory } from 'react-router-dom'
import { swalMessages } from 'src/constants'
import { Context } from 'src/context/Contex'
import * as paths from 'src/routes/paths'
import { permitsList } from 'src/constants/permits'
import swal from 'sweetalert'
import adminInventoryService from 'src/services/adminInventoryService'

const UsersInventoryContainer = () => {
  const [users, setUsers] = useState([])
  const [usersBlocked, setUsersBlocked] = useState([])
  const [loading, setLoading] = useState(false)
  const { permisos, setUserId } = useContext(Context)

  const history = useHistory()

  const getUsers = async () => {
    setLoading(true)
    const response = await adminInventoryService.getAllUsers()
    try {
      const dataTable = response.map((user) => ({
        name: user.nombre,
        apellido: user.apellido,
        mail: user.correo,
        id: user.id,
        idCreation: 0,
      }))
      setUsers(dataTable)
    } catch (err) {
      console.log(err)
    }
  }

  const getBlockedUsers = async () => {
    setLoading(true)
    const response = await adminInventoryService.getAllUsers()
    try {
      const dataTable = response.map((user) => ({
        name: user.nombre,
        apellido: user.apellido,
        mail: user.correo,
        id: user.id,
        idCreation: 0,
      }))
      setUsersBlocked(dataTable)
    } catch (err) {
      console.log(err)
    }
  }

  const columns = [
    { title: 'Nombre', field: 'name' },
    { title: 'Apellido', field: 'apellido' },
    { title: 'Correo', field: 'mail' },
    { title: 'id', field: 'id', hidden: true },
  ]

  useEffect(() => {
    setLoading(false)
    getUsers()
  }, [])

  const handleEdit = ({ event, rowData }) => {
    event.preventDefault()
    setUserId(rowData)
    history.push(paths.ADMIN_USERS_DESTINATERIE)
  }
  const handleClick = (event) => {
    event.preventDefault()
    history.push(paths.ADMIN_USERS_CREATOR_INVENTORY)
  }

  const handleDelete = ({ rowData }) => {
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        await adminInventoryService.deleteUser(rowData.id)
        getUsers()
      }
    })
  }

  const handleUnlock = ({ rowData }) => {
    swal(swalMessages.UNLOCK_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        await adminInventoryService.unlockuser(rowData.correo)
        getUsers()
      }
    })
  }

  const minValue = permisos[permitsList.ADMIN_USER_INVENTARIO]

  return (
    <AdminControl
      users={users}
      usersBlocked={usersBlocked}
      minValue={minValue}
      permisos={permisos}
      columns={columns}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleClick={handleClick}
      handleUnlock={handleUnlock}
      loading={loading}
    />
  )
}

export default UsersInventoryContainer
